// Extrait verbatim de src/components/Sidebar.js (découpe iso du 06/09/2026).
import React, { useState, useRef, useEffect } from 'react';
import { LayoutDashboard } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { SECTION_ICONS } from './sidebarShared';

function CollapsedCategory({ cat, visibleItems, hasActive, customLabels, location }) {
  const [flyoutOpen, setFlyoutOpen] = useState(false);
  const ref = useRef(null);
  const SectionIcon = SECTION_ICONS[cat.id] || LayoutDashboard;

  useEffect(() => {
    if (!flyoutOpen) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setFlyoutOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [flyoutOpen]);

  return (
    <div ref={ref} style={{ position: 'relative' }}>
      {/* Section icon button */}
      <button
        onClick={() => setFlyoutOpen(!flyoutOpen)}
        title={customLabels?.[`cat:${cat.id}`] || cat.label}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          width: '100%', padding: '10px 0', border: 'none',
          background: hasActive ? 'rgba(255,255,255,0.1)' : 'transparent',
          borderLeft: hasActive ? '3px solid #5ba3e6' : '3px solid transparent',
          cursor: 'pointer',
          color: hasActive ? '#fff' : 'rgba(255,255,255,0.5)',
          transition: 'all 0.15s',
        }}
      >
        <SectionIcon size={18} />
      </button>

      {/* Flyout popup */}
      {flyoutOpen && (
        <div style={{
          position: 'fixed',
          left: 64, top: ref.current ? ref.current.getBoundingClientRect().top : 0,
          background: '#1e4264', border: '1px solid rgba(255,255,255,0.15)',
          borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.4)',
          padding: '6px 0', minWidth: 200, zIndex: 9999, textAlign: 'left',
        }}>
          <div style={{
            padding: '6px 14px 8px', fontSize: 11, fontWeight: 700, letterSpacing: 1.5,
            color: 'rgba(255,255,255,0.55)', fontFamily: "'IBM Plex Mono', monospace", textAlign: 'left',
          }}>
            {customLabels?.[`cat:${cat.id}`] || cat.label}
          </div>
          {visibleItems.map(item => {
            const Icon = item.icon;
            const isActive = location.pathname === item.path || location.pathname.startsWith(item.path + '/');
            return (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setFlyoutOpen(false)}
                style={{
                  display: 'flex', alignItems: 'center', gap: 10, justifyContent: 'flex-start',
                  padding: '8px 14px', textDecoration: 'none', fontSize: 14, textAlign: 'left',
                  color: isActive ? '#fff' : 'rgba(255,255,255,0.85)',
                  background: isActive ? 'rgba(255,255,255,0.1)' : 'transparent',
                  fontWeight: isActive ? 600 : 400,
                  transition: 'background 0.1s',
                }}
                onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = 'rgba(255,255,255,0.06)'; }}
                onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = 'transparent'; }}
              >
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 20, flexShrink: 0 }}>
                  <Icon size={15} />
                </span>
                <span>{customLabels?.[item.path] || item.label}</span>
              </NavLink>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default CollapsedCategory;
